module.exports = __webpack_public_path__ + "static/media/Inter-Bold.1217aaef.woff2";